var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "label",
    {
      staticClass: "col-4",
    },
    [
      _c(
        "span",
        {
          staticClass: "required",
        },
        [_c("translate", [_vm._v("Dateipfad")])],
        1
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.thePath,
            expression: "thePath",
          },
        ],
        attrs: {
          required: "",
          type: "text",
          name: "path",
        },
        domProps: {
          value: _vm.thePath,
        },
        on: {
          input: function input($event) {
            if ($event.target.composing) return
            _vm.thePath = $event.target.value
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }